export class User {
  constructor (
    public id: number,
    public email: string,
    public firstName: string,
    public lastName: string,
    public teamId: number,
    public teamName: string,
    public role: number,
    public isActive: number,
    public createTime: string,
    public modifyTime: string,
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/user.ts